import { useMediaQuery } from 'utilities/hooks/useMediaQuery';

// current maximum screen width (iPad Pro)
const breakpointMediaQuery = `(max-width: 1366px)`;

export const useIsTablet = () =>
  useMediaQuery(breakpointMediaQuery) && Wahanda.Util.isTouchDevice();
